module.exports = __webpack_public_path__ + "static/media/cy.9f04989a.svg";